import { DataService } from 'core/data/service'
import { Observable } from 'rxjs/Observable'

export class ChaordicService extends DataService {
    constructor() {
        super(false)
    }

    buildCarrinho(carrinho) {
        const itens = carrinho.itens;

        return {
            items: itens.map((item) => {
                let produto = {
                    pid: `${item.codigo}`,
                    sku: `${item.codigo}`,
                    price: Number(item.valorPorUnitario.toFixed(2)),
                    quantity: Number(item.quantidade)
                }

                if(this.getValueCookieByName("chaordicsID")){
                    produto.user = this.getValueCookieByName("chaordicsID")
                }
                
                return produto;
            })
        }
        
    }

    buildPage() {
        return {
            name: "cart",
            timestamp: new Date()
        }
    }

    //send chaordic impression event
    sendImpressionEvent(url) {
        const options = {
            method: 'GET',
            url: url
        }

        return Observable
                .fromPromise(super.request(options));
    }

    //send chaordic click event
    sendClickEvent(url) {
        const options = {
            method: 'GET',
            url: url
        }

        return Observable
                .fromPromise(super.request(options));
    }

    getValueCookieByName (cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i <ca.length; i++) {
            let c = ca[i];
  
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
  
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/chaordic/chaordic.service.js